import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      setEmail('');
      return;
    }
    formData.delete('website_alt');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9sr8mdlbrt1qcgaj8l0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const serverMsg = (parsed?.meta as Record<string, string>)?.message || (parsed as Record<string, string>)?.message || (parsed?.meta as Record<string, string>)?.detail || '';
      if (response.ok && (parsed as Record<string, string>)?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20pink%20and%20cream%20gradient%20background%20with%20floating%20cherry%20blossom%20petals%2C%20dreamy%20ethereal%20atmosphere%2C%20subtle%20glow%20effect%2C%20minimalist%20abstract%20art%2C%20warm%20gentle%20tones&width=1800&height=600&seq=cta-bg-kissxsis&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-50/60"></div>
      </div>
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          加入亲吻姐姐粉丝社区
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 font-body">
          订阅我们的更新，第一时间获取亲吻姐姐最新解析、名场面回顾和动漫推荐内容
        </p>
        <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form>
          <div className="honeypot-wrapper">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-background-50 border border-background-300/60 text-sm font-body text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <button
            type="submit"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-body text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            立即订阅
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-4 text-sm text-green-600 font-body">订阅成功！感谢你的关注！</p>
        )}
        <p className="mt-4 text-xs text-foreground-400 font-body">
          我们尊重你的隐私，不会发送垃圾邮件
        </p>
      </div>
    </section>
  );
}